import React, { Component } from 'react'
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import _ from 'lodash';
import { OrderActions } from '../../actions';
import OrderList from '../../components/Orders/List';
import Loader from '../../components/Loader';
import TitleBar from '../../components/TitleBar';
import SubnavBar from '../../components/SubnavBar';
import VoidShipmentConfirm from '../Modals/VoidShipmentConfirm';
import UpdateStatus from '../Modals/UpdateStatus';


export class Orders extends Component {
  constructor(props) {
    super(props);

    this.voidOrder = this.voidOrder.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.confirmVoid = this.confirmVoid.bind(this);
    this.selectRows = this.selectRows.bind(this);
    this.updateOrders = this.updateOrders.bind(this);
    this.handleStatusChange = this.handleStatusChange.bind(this);
    this.handleStatusClose = this.handleStatusClose.bind(this);

    this.state = {
      open: false,
      statusOpen: false,
      rows: null,
    }
  }
  componentWillMount() {
    this.props.dispatch(OrderActions.getAllOrders());
  }

  newOrder = () => {
    browserHistory.push('/order');
  }

  gotoDelivered = () => {
    browserHistory.push('/orders/delivered');
  }

  voidOrder = (id) => {
    this.setState({
      open: true,
      orderId: id
    });
  }
  confirmVoid() {
    this.props.dispatch(OrderActions.voidOrder(this.state.orderId)).then(order => {
      this.setState({ open: false, orderId: null });
      this.props.dispatch(OrderActions.getAllOrders());
    })
  }

  selectRows(rows) {
    this.setState({rows});
  }

  updateOrders(event) {
    this.setState({ statusOpen: true });
  }

  handleStatusChange(status, pod) {
    const { rows } = this.state;
    this.setState({ statusOpen: false, rows: [] });

    const orders = {
      values: {
        statusId: status
      },
      orders: rows
    };

    if (pod) {
      orders.pod = pod;
    }

    this.props.dispatch(OrderActions.updateOrders(orders)).then((updated) => {
      this.props.dispatch(OrderActions.getAllOrders());
    });
  }

  handleClose() {
    this.setState({ open: false, orderId: null });
  }

  handleStatusClose() {
    this.setState({ statusOpen: false });
  }

  render() {
    const { auth, orders } = this.props;
    const profile = auth.getProfile();
    const isAdmin = _.includes(profile.roles, 'admin');
    const isDispatcher = _.includes(profile.roles, 'dispatcher');
    let content;
    if (!orders || orders.fetching === true || !orders.list) {
      content = (<Loader />);
    } else {
      content = <OrderList dataProvider={orders.list} voidOrder={this.voidOrder} onRowSelection={this.selectRows} isAdmin updateOrder={this.updateOrders} />
    }
    const subnavItems = [
      { key: 1, label: 'New', onClick: this.newOrder },
      { key: 2, label: 'Delivered', onClick: this.gotoDelivered }
    ];

    if (isAdmin || isDispatcher) {
      subnavItems.push( { key: 3, label: 'Update Selected', onClick: this.updateOrders, disabled: (!this.state.rows || this.state.rows.length === 0) } );
    }
    return (
      <div className="row">
        <div className="col s12">
          <SubnavBar items={subnavItems} />
          <TitleBar title="Orders" />
          <div className="row">
            <div className="col s12">
              {content}
            </div>
          </div>
          <VoidShipmentConfirm onClose={this.handleClose} onConfirm={this.confirmVoid} open={this.state.open} />
          <UpdateStatus onClose={this.handleStatusClose} onConfirm={this.handleStatusChange} open={this.state.statusOpen} />
        </div>
      </div>
    )
  }
}

const mapPropsToState = (state) => {
  const { auth, orders } = state;
  return {
    auth: auth.auth,
    orders
  }
}

export default connect(mapPropsToState)(Orders);


// WEBPACK FOOTER //
// ./src/containers/Orders/index.js